export default __webpack_public_path__ + "static/balloon-guy-e713d3339c25902650d95ce4eda903ac.svg";